export default __webpack_public_path__ + "static/media/folder.0a73d340.svg";